import { ChangeEvent, FunctionComponent } from 'react';

// Components
import * as Yup from 'yup';
import Image from '@Components/Utils/Image';

// Styles
import styles from './Contact.module.scss';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';

// Utilities
import { useFormik } from 'formik';
import classnames from 'classnames';
import { phoneRegExp, useSupportAirTable } from '@Libs/utils';

// Icons
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLoading from '@Components/UI/ButtonLoading';

const validationSchema = Yup.object({
    phoneNumber: Yup.string().required('Vui lòng nhập số điện thoại!').min(9, 'Số điện thoại chưa đúng!').matches(phoneRegExp, 'Số điện thoại chưa đúng!'),
});

interface SuggestProps {
    className?: string;
}

const Contact: FunctionComponent<SuggestProps> = (props) => {
    const { deviceType } = useViewDetected();
    const { loading, sendSupport } = useSupportAirTable();

    const { values, errors, setFieldValue, handleSubmit } = useFormik({
        validationSchema,
        initialValues: {
            phoneNumber: '',
        },
        onSubmit: () => sendSupport(values.phoneNumber),
    });

    const handleChangeValue = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setFieldValue('phoneNumber', value, !!errors.phoneNumber);
    };

    const className = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        props.className,
    ]);

    const btnClassName = classnames([
        styles.btn_send,
        {
            [styles.btn_loading]: loading,
        },
    ]);

    return (
        <form className={className} onSubmit={handleSubmit}>
            <Image width={242} height={136} src={'/assets/bottomAction/contact.png'} className={styles.image_top} />
            <div className={styles.title}>Bạn vẫn chưa đủ thông tin?</div>
            <div className={styles.sub_title}> Vui lòng để lại thông tin số điện thoại, eDoctor sẽ liên hệ bạn ngay nhé!</div>
            <div className={styles.input_group}>
                <input disabled={loading} autoComplete="off" value={values.phoneNumber} className={styles.input_phone} onChange={handleChangeValue} placeholder="Nhập số điện thoại" />
                <ButtonLoading loading={loading} className={btnClassName}>
                    Gửi
                </ButtonLoading>
            </div>
            {errors.phoneNumber && (
                <label className={styles.phone_group_error}>
                    <FontAwesomeIcon className={styles.icon} icon={faTimesCircle} />
                    {errors.phoneNumber}
                </label>
            )}
        </form>
    );
};

Contact.defaultProps = {
    className: '',
};

export default Contact;
